export * from './AccountDescription';
export * from './ContactDescription';
export * from './DealDescription';
export * from './InvoiceDescription';
export * from './LeadDescription';
export * from './ProductDescription';
export * from './PurchaseOrderDescription';
export * from './QuoteDescription';
export * from './SalesOrderDescription';
export * from './VendorDescription';
